import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import { Icon, Tooltip, message } from 'antd';
import { FaGavel } from 'react-icons/fa';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Modal from 'react-modal';

import { addJudge as addJudgeApi } from '../../../api-calls/customWagers';
import { addJudge as addContractJudge } from '../../../contract/CustomWagersController';
import { ethMultiplier } from '../../../constants';

Modal.setAppElement('#root')

@observer(["CustomWagerStore", "AuthStore"])
class StepFive extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modalIsOpen: false,
            loading: true,
            toolTipMessage: 'Click to Copy',
            judgeEthAddress: '',
            customWager: {},
            addingJudgeLoading: false,
            wagerIdObj: '',
            judgeAdded: false
        };
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleChangeAdminAddress = this.handleChangeAdminAddress.bind(this);
        this.handleClickSubmitAddJudge = this.handleClickSubmitAddJudge.bind(this);
    }

    componentWillMount() {
        const { CustomWagerStore } = this.props;
        let self = this;
        CustomWagerStore.querySingleCustomWagerByBytes32Id(this.props.wagerBytes32Id).then(() => {
            setTimeout(() => {
                let customWagers = Array.from(CustomWagerStore.singleCustomWagerBytes32Id.values());
                customWagers.forEach(customWager => {
                    self.setState({ wagerIdObj: customWager._id })
                });
            }, 250)
            setTimeout(() => {
                self.setState({ loading: false })
            }, 350)

        });

        setTimeout(() => {
            self.setState({ loading: false })
        }, 350)
    }

    renderCustomWagers() {
        const { CustomWagerStore } = this.props;
        let customWagerList = []
        console.log("wagerBytes32Id ::::" + this.props.wagerBytes32Id)
        let customWagers = Array.from(CustomWagerStore.singleCustomWagerBytes32Id.values());
        customWagers.forEach(customWager => {
            let endTime = new Date(customWager.endTime * 1000).toLocaleString();
            let reportingEndTime = new Date(customWager.reportingEndTime * 1000).toLocaleString();
            customWagerList.push(
                <div key={customWager._id} className="custom-bet-modal-finalize-wrap">
                    <div className="custom-bet-modal-finalize-betId-wrap">
                        <div className="custom-bet-modal-finalize-betId-title">Your Bet ID</div>
                        <CopyToClipboard text={customWager._id} onCopy={() => this.setState({ toolTipMessage: 'Copied!' })}>
                            <Tooltip placement="bottom" title={this.state.toolTipMessage}>
                                <div className="custom-bet-modal-finalize-betId">{customWager._id}</div>
                            </Tooltip>
                        </CopyToClipboard>
                    </div>
                    <div className="custom-bet-modal-finalize-grid">
                        <div className="custom-bet-modal-finalize-grid-cell">
                            <div>Value</div>
                            <span>{(customWager.value/ethMultiplier).toFixed(4)}</span>
                        </div>
                        <div className="custom-bet-modal-finalize-grid-cell">
                            <div>Odds</div>
                            <span>{customWager.odds/100}</span>
                        </div>
                        <div className="custom-bet-modal-finalize-grid-cell">
                            <div>End Time</div>
                            <span>{endTime}</span>
                        </div>
                        <div className="custom-bet-modal-finalize-grid-cell">
                            <div>Reporting End Time</div>
                            <span>{reportingEndTime}</span>
                        </div>
                        <div className="custom-bet-modal-finalize-grid-cell">
                            <div>Second Outcome</div>
                            <span>{customWager.outcomeOne}</span>
                        </div>
                        <div className="custom-bet-modal-finalize-grid-cell">
                            <div>First Outcome</div>
                            <span>{customWager.outcomeTwo}</span>
                        </div>
                    </div>
                    <div className="custom-bet-modal-finalize-add-judge-wrap">
                    {/* ADD A JUDGE */}
                        {/*!this.state.judgeAdded ?
                            <button onClick={this.openModal} className="custom-btn-primary" style={{ width: '60%' }}>
                                <span className="custom-bet-modal-judge-icon"><FaGavel /></span> Assign a judge</button>
                            :
                            null
                        */}
                    </div>
                </div>
            )
        });

        return customWagerList;
    }

    handleClickSubmitAddJudge() {
        this.setState({ addingJudgeLoading: true })
        const { AuthStore } = this.props;
        let self = this;
        let authToken = AuthStore.userAuth.auth.accessToken;
        let judgeAddress = this.state.judgeEthAddress;
        let wagerId = this.state.wagerIdObj;
        let wagerBytes32Id = this.props.wagerBytes32Id;
        console.log("wagerId ::::" + wagerId)
        console.log("wagerBytes32Id ::::" + wagerId)



        return addContractJudge(wagerBytes32Id, judgeAddress).then(
            function (result) {
                if (String(result).includes('User denied transaction signature')) {
                    message.warning("Metamask transaction denied! No judge assigned.");
                    self.setState({ addingJudgeLoading: false });
                } else {
                    return addJudgeApi(
                        authToken,
                        wagerId,
                        judgeAddress)
                        .then(() => {
                            self.setState({ addingJudgeLoading: false, judgeAdded: true });
                            message.success("Judge successfully added!");
                            self.closeModal();
                        })
                }
            });
    }

    handleChangeAdminAddress(e) {
        this.setState({ judgeEthAddress: e.target.value });
    }

    openModal() {
        this.setState({ modalIsOpen: true });
    }

    afterOpenModal() {
        // references are now sync'd and can be accessed.
        //this.subtitle.style.color = '#f00';
    }

    closeModal() {
        this.setState({ modalIsOpen: false });
    }

    render() {

        return (
            <div>
                <h1>Your bet details</h1>
                {!this.state.loading ?
                    this.renderCustomWagers()
                    :
                    <div className="custom-bet-modal-finalize-wrap">
                        <div style={{ textAlign: 'center', marginTop: '65px', fontSize: '60px' }}>
                            <Icon type="loading" />
                        </div>
                    </div>
                }
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onAfterOpen={this.afterOpenModal}
                    onRequestClose={this.closeModal}
                    contentLabel="Custom Bet Modal"
                    className="add-judge-modal"
                    overlayClassName="add-judge-modal-overlay"
                >
                    <div className="add-judge-modal-content-wrap">
                        <div className="add-judge-modal-content-header">
                            Assign a Judge
                            <div className="add-judge-modal-content-header-close-btn" onClick={this.closeModal}><Icon type="close-circle" /></div>
                        </div>
                        <div className="add-judge-modal-content">
                            {!this.state.addingJudgeLoading ?
                                <div className="add-judge-modal-content-form-field">
                                    <div className="add-judge-modal-content-form-field-title">Judge Address</div>
                                    <input type="text"
                                        onChange={this.handleChangeAdminAddress}
                                        value={this.state.judgeEthAddress}
                                        className="custom-input"
                                        placeholder="Enter Judge's ETH Address"
                                    />
                                </div>
                                :
                                <div style={{ fontSize: '54px', marginTop: '10px', textAlign: 'center' }}><Icon type="loading" /></div>
                            }
                        </div>
                        <div className="add-judge-modal-actions">
                            <button onClick={this.closeModal} className="custom-btn-danger">Cancel</button>
                            <button onClick={this.handleClickSubmitAddJudge} className="custom-btn-primary">Submit</button>
                        </div>
                    </div>

                </Modal>
            </div>
        );
    }
}

export default StepFive;


// WEBPACK FOOTER //
// ./src/components/layoutComponents/customBetSteps/StepFive.js